import clsx from 'clsx'
import React, { HTMLProps, PropsWithChildren } from 'react'

import Styles from './PublicLayout.module.scss'

interface IPublicLayoutProps
  extends PropsWithChildren,
    HTMLProps<HTMLDivElement> {
  variant?: 'white' | 'transparent'
}

const PublicLayout: React.FC<IPublicLayoutProps> = ({
  children,
  variant = 'white',
  ...props
}) => {
  return (
    <div
      className={clsx(Styles.publicLayout)}
      {...props}
      data-testid="public-layout">
      <header className={clsx(Styles.header, Styles[variant])}>
        <div className={clsx(Styles.headerContent, Styles.container)}>
          <img
            className={Styles.logo}
            alt="logo"
            src="/images/yassir-text-logo.svg"
          />
          {/* <LanguageSelect /> */}
        </div>
      </header>
      <div className={clsx(Styles.content, Styles.container)}>{children}</div>
    </div>
  )
}

export default PublicLayout
